import { Slide } from "react-awesome-reveal";
import Lottie from 'react-lottie';
import type { ServiceCardProps } from '../store/types';

const defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

const ServiceCard = ({ title, description, animationData, delay = 100 }: ServiceCardProps) => {
    const headingId = `service-card-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`;

    return (
        <div className="col-lg-4 service mt-3 d-flex">
            <Slide triggerOnce delay={delay}>
                <article className="bg-light border-radius-25 p-3 text-center h-100" aria-labelledby={headingId}>
                    <div className="service-circle mx-auto">
                        <div className="lottie-wrapper" style={{ width: 50 }} aria-hidden="true">
                            <Lottie
                                options={{ ...defaultOptions, animationData }}
                                height={50}
                                width={50}
                                style={{ textAlign: 'left' }}
                            />
                        </div>
                    </div>
                    <h3 id={headingId} className="title fw-700 mt-3">{title}</h3>
                    <p className="description mt-2">{description}</p>
                </article>
            </Slide>
        </div>
    );
};

export default ServiceCard;
